import { create } from 'zustand';

import {
  addPendingFavoriteRemove,
  readPendingFavoriteRemoveIds,
  removePendingFavoriteRemove,
} from '../lib/pendingRemoval';

interface FavoritePendingUiState {
  ids: number[];
  refresh: () => void;
  add: (productId: number) => void;
  remove: (productId: number) => void;
}

export const useFavoritePendingUiStore = create<FavoritePendingUiState>(
  (set) => ({
    ids: [],
    refresh: () => set({ ids: readPendingFavoriteRemoveIds() }),
    add: (productId) => {
      addPendingFavoriteRemove(productId);
      set({ ids: readPendingFavoriteRemoveIds() });
    },
    remove: (productId) => {
      removePendingFavoriteRemove(productId);
      set({ ids: readPendingFavoriteRemoveIds() });
    },
  }),
);
